import { createContext, ReactNode, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";

import { LOGOUT, LogoutReasons } from "@store/user/userActions";
import { RootState } from "@types-runway/state";
import { User } from "@types-runway/user";

const AuthContext = createContext<{
  isAuth: boolean;
  token: string | null;
  handleSessionExpired: () => void;
}>({
  isAuth: false,
  token: null,
  handleSessionExpired: () => {},
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();
  const user = useSelector<RootState, User>((state) => state.user.data);
  const token = localStorage.getItem("token");
  const isAuth = Boolean(user.id && token);

  // The login page explains the expiry (LoginPage reads LogoutReasons from router state).
  const handleSessionExpired = () => {
    dispatch({ type: LOGOUT, userId: user.id, reason: LogoutReasons.SESSION_EXPIRED });
  };

  return (
    <AuthContext.Provider value={{ isAuth, token, handleSessionExpired }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
